// extracted by mini-css-extract-plugin
export default {"header":"ForgotPassword_header__z1UAd","form":"ForgotPassword_form__tQwEm"};